import React from 'react';
import { Box, Container, Typography, Grid, Stack } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SchoolIcon from '@mui/icons-material/School';
import CheckIcon from '@mui/icons-material/Check';
import { landingThemeConfig } from '../styles/landingThemeConfig';

const advantages = [
  {
    icon: <AutoAwesomeIcon sx={{ fontSize: 48 }} />,
    title: 'Your Personal Exam, Instantly',
    description: 'No more irrelevant questions. Select your exact topics and difficulty, and generate a perfect practice exam in seconds.',
  },
  {
    icon: <SchoolIcon sx={{ fontSize: 48 }} />,
    title: 'Practice with the Real Deal',
    description: 'Our database is built from thousands of real, vetted past HSC questions, so you\'re practicing what actually matters.',
  },
  {
    icon: <CheckIcon sx={{ fontSize: 48 }} />,
    title: 'Turn Weak Spots into Strengths',
    description: 'Struggling with Integration by Parts? Generate a 15-mark quiz focused entirely on that topic until you master it.',
  },
];

const StudentAdvantages = ({ colorTheme = 'teal' }) => {
  const studentTheme = landingThemeConfig.student(colorTheme);
  return (
    <Box 
      sx={{ 
        py: { xs: 10, md: 15 },
        backgroundColor: 'transparent',
      }}
    >
      <Container maxWidth="lg">
        {/* Section Title */}
        <Box textAlign="center" mb={8}>
          <Typography 
            variant="h2" 
            sx={{ 
              mb: 2,
              fontWeight: 700,
              background: `linear-gradient(135deg, ${studentTheme.components.hero.titleGradientStart} 0%, ${studentTheme.components.hero.titleGradientEnd} 100%)`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Your Unfair Advantage
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
            Stop wasting hours searching for practice papers. Start studying smarter with AI-powered exam generation.
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 6, md: 8 }}>
          {advantages.map((advantage, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Stack 
                spacing={2} 
                alignItems="center" 
                textAlign="center"
                sx={{
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: studentTheme.components.features.cardHoverTransform,
                  },
                }}
              >
                <Box
                  sx={{
                    color: 'primary.main',
                    p: 2,
                    borderRadius: 2,
                    bgcolor: studentTheme.components.features.iconBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {advantage.icon}
                </Box>
                <Typography variant="h3" fontWeight={600}>
                  {advantage.title}
                </Typography>
                <Typography 
                  variant="body1" 
                  color="text.secondary"
                  sx={{ maxWidth: 320, lineHeight: 1.7 }}
                >
                  {advantage.description}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default StudentAdvantages;